import withPrivateRoute from '@/components/hoc/withPrivateRoute';
import { ROLES_PERMISSIONS } from '@/constants';
import { QueryParamsProvider } from '@/contexts/query-params/QueryParamsProvider';
import ReportsPage from './ReportsPage';

const DEFAULT_PARAMS = { company: 'all' };

function PrivateReports() {
  return (
    <QueryParamsProvider defaultParams={DEFAULT_PARAMS}>
      <ReportsPage />
    </QueryParamsProvider>
  );
}

const Reports = withPrivateRoute(
  PrivateReports,
  ROLES_PERMISSIONS.TIME_TRACKING.VIEW
);

export default Reports;
